import { React, useState } from 'react';
import { useTheme } from 'styled-components';
import logo from '../../assets/logo.png';
import moon from '../../assets/moon.png';
import sun from '../../assets/sun.png';
import hamburger from '../../assets/hamburger.png'
import Navbar from '../NavigationComponents/Navbar';
import Sidebar from '../NavigationComponents/Sidebar';



function Header({ toggleTheme, isDarkMode, user, onLogout, hasMessages }) {
  const theme = useTheme();

  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 2rem',
    backgroundColor: theme.colors.card,
    color: theme.colors.text,
    boxShadow: `0 4px 16px ${theme.colors.shadow}60`,
  };

  const buttonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: theme.colors.text,
  };

  return (
    <div style={headerStyle}>
      <img src={logo} alt="Logo" width="50" height="50" />
      <Navbar user={user} onLogout={onLogout} />
      <div style={{ display: 'flex', gap: '1rem' }}>
        <button onClick={toggleTheme} style={buttonStyle}>
          {isDarkMode
            ? <img src={sun} alt="Sun" width="50" height="50" />
            : <img src={moon} alt="Moon" width="50" height="50" />}
        </button>

        {user && (
          <div style={{ position: "relative", display: "inline-block" }}>
            <button style={buttonStyle} onClick={toggleSidebar}>
              <img src={hamburger} alt="Menu" width="50" height="50" />
            </button>

            {hasMessages && (
              <img
                src={require('../../assets/notification.png')}
                alt="New messages"
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "20px",
                  height: "20px",
                }}
              />
            )}
          </div>
        )}

      </div>
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} user={user} hasMessages={hasMessages} />
    </div>
  );
}

export default Header;

